import { attr, belongsTo } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/variant-model';
import {
  buildValidations,
  disabledWhenVariant,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  url: validator('presence', {
    presence: true,
    disabled: disabledWhenVariant(),
  }),
});

export const settings = {
  variantProperties: ['altText', 'cmsLanguageId', 'cmsState', 'headline'],
};

export default class LinkModel extends Model.extend(Validations) {
  @attr('string') headline;
  @attr('string') url;
  @attr('string') linkOptions;
  @attr('string') altText;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Getter and setter
  get displayHeadline() {
    return this.headline;
  }

  get displayLabel() {
    return `${this.headline} — ${this.url}`;
  }
}
